import { useRedux } from '../../../../hooks';

export default function useLastFriends() {
    const { appSelector } = useRedux();
    const { lastFriends, friendsCount } = appSelector((state) => ({
        friendsCount: state.Friendship.friendsCount,
        lastFriends: state.Friendship.lastFriends,
    }));
    return {
        lastFriends,
        friendsCount,
    };
}
